module.exports = __webpack_public_path__ + "static/media/material-android-logo.60751a41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/material/material-android-logo.png
// module id = 1108
// module chunks = 114